// src/components/ui.js — shared primitives
import { Loader2 } from 'lucide-react'

export const STATUS_COLORS = {
  PENDING:        'bg-yellow-500/10 text-yellow-400 border-yellow-500/20',
  CONFIRMED:      'bg-blue-500/10 text-blue-400 border-blue-500/20',
  READY:          'bg-green-500/10 text-green-400 border-green-500/20',
  PICKED_UP:      'bg-gray-500/10 text-gray-400 border-gray-500/20',
  FAILED:         'bg-red-500/10 text-red-400 border-red-500/20',
  CANCELLED:      'bg-gray-500/10 text-gray-500 border-gray-500/20',
  REFUND_PENDING: 'bg-orange-500/10 text-orange-400 border-orange-500/20',
  REFUNDED:       'bg-purple-500/10 text-purple-400 border-purple-500/20',
  OPEN:           'bg-red-500/10 text-red-400 border-red-500/20',
  UNDER_REVIEW:   'bg-amber-500/10 text-amber-400 border-amber-500/20',
  RESOLVED:       'bg-green-500/10 text-green-400 border-green-500/20',
  INITIATED:      'bg-yellow-500/10 text-yellow-400 border-yellow-500/20',
  PROCESSING:     'bg-blue-500/10 text-blue-400 border-blue-500/20',
  SUCCESS:        'bg-green-500/10 text-green-400 border-green-500/20',
}

export function Badge({ label }) {
  const cls = STATUS_COLORS[label] || 'bg-gray-500/10 text-gray-400 border-gray-500/20'
  return (
    <span className={`text-[10px] font-bold uppercase tracking-widest px-2 py-0.5 rounded-full border ${cls}`}>
      {label}
    </span>
  )
}

export function MetricCard({ label, value, sub, accent }) {
  return (
    <div className="bg-[#1c1c1e] rounded-2xl p-4 border border-white/5">
      <p className="text-gray-500 text-[10px] font-bold uppercase tracking-widest mb-1">{label}</p>
      <p className={`text-2xl font-bold ${accent || 'text-white'}`}>{value ?? '—'}</p>
      {sub && <p className="text-gray-600 text-[10px] mt-1">{sub}</p>}
    </div>
  )
}

export function Spinner() {
  return <div className="flex items-center justify-center py-12"><Loader2 className="w-6 h-6 text-orange-500 animate-spin" /></div>
}

export function SectionTitle({ children }) {
  return <h2 className="text-white font-semibold text-sm tracking-wide mb-3">{children}</h2>
}

export function TableWrap({ children }) {
  return (
    <div className="overflow-x-auto rounded-2xl border border-white/5">
      <table className="w-full text-xs text-gray-300 border-collapse">
        {children}
      </table>
    </div>
  )
}

export function Th({ children, right }) {
  return (
    <th className={`px-3 py-2.5 bg-[#1c1c1e] text-gray-500 font-bold uppercase tracking-widest text-[10px] border-b border-white/5 ${right ? 'text-right' : 'text-left'} whitespace-nowrap`}>
      {children}
    </th>
  )
}

export function Td({ children, right, mono }) {
  return (
    <td className={`px-3 py-2.5 border-b border-white/5 ${right ? 'text-right' : ''} ${mono ? 'font-mono' : ''}`}>
      {children}
    </td>
  )
}

export function formatRupees(n) {
  if (n == null) return '—'
  return '₹' + Number(n).toLocaleString('en-IN')
}

export function formatTime(ts) {
  if (!ts) return '—'
  return new Date(ts).toLocaleString('en-IN', {
    day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit'
  })
}

export function timeAgo(ts) {
  if (!ts) return '—'
  const diff = Date.now() - new Date(ts).getTime()
  const m = Math.floor(diff / 60000)
  if (m < 60) return `${m}m ago`
  const h = Math.floor(m / 60)
  if (h < 24) return `${h}h ago`
  return `${Math.floor(h / 24)}d ago`
}